import type { Product } from "../types/marketplace";
import CardItem from "./CardItem";

interface ProductGridProps {
  products: Product[];
  compact?: boolean;
  className?: string;
  comparedProductIds?: string[];
  onCompareToggle?: (product: Product) => void;
  onProductSelect?: (product: Product) => void;
}

function ProductGrid({
  products,
  compact = false,
  className = "products-grid",
  comparedProductIds = [],
  onCompareToggle,
  onProductSelect
}: ProductGridProps) {
  return (
    <div className={className}>
      {products.map((product) => (
        <CardItem
          compact={compact}
          isCompared={Boolean(product.id && comparedProductIds.includes(product.id))}
          item={product}
          key={product.id ?? product.name}
          onCompareToggle={onCompareToggle}
          onSelect={onProductSelect}
        />
      ))}
    </div>
  );
}

export default ProductGrid;
